export default "__VITE_ASSET__BBjCeX2M__"